import React from 'react';
var AsyncMomentTz = React.lazy(function () {
  return import('moment-timezone').then(function () {
    return {
      default: function _default(props) {
        return props.substituent;
      }
    };
  });
});

var Spinner = function Spinner() {
  return React.createElement("span", null, "Loading...");
};

function withMomentTz(WrappedComponent) {
  return function (props) {
    return React.createElement(React.Suspense, {
      fallback: React.createElement(Spinner, null)
    }, React.createElement(AsyncMomentTz, {
      substituent: React.createElement(WrappedComponent, props)
    }));
  };
}

export default withMomentTz;